import { EnvironmentType } from "@env/EnvironmentType";

export const environment: EnvironmentType = {
  production: true,
  testSystem: false,
  apiHostname: "api",
  wsHostname: "wss://turnportal.de/ws",
  licenceExtensionAllowedFrom: { month: 11, day: 1 },
};
